<template src="./IntegrateBP.html">
</template>

<script>
import axios from 'axios'
import {mask} from "vue-the-mask"
import tooltips from '@/utilities/tooltips.js'
import coreAddressComponent from "@/components/core/CoreAddress"
import locationComponent from "@/components/Location"
import * as common from "@/common.js"
import {forceCorrectDate, IsArrayNotPopulated} from "@/common.js"
import * as spaApi from "@/spaApi.js"
import loading from '@/components/PageLoader'
import list from "@/components/core/CoreBMSMatchList"
import moment from 'moment'
import bpPolicyComponent from '@/components/core/CoreBPPolicyHeader'
import epicPolicyComponent from '@/components/core/CoreEPICPolicyHeader'
import ConfirmationModal from '@/components/global/ConfirmationModal'
import submitModal from '@/components/global/SubmitModal'
import contactComponent from '@/components/core/CoreContact'
import credentialsModal from "@/components/global/CredentialsModal.vue";
import accountStructureTableComponent from '@/components/core/CoreAccountStructureTable'
import {agencycode, instance, targets} from "@/constants";
import {required} from "vee-validate/dist/rules";

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  components: {
    loading,
    list,
    'location-section': locationComponent,
    'core-address-section': coreAddressComponent,
    'core-bp-policy-header-section': bpPolicyComponent,
    'confirmation-modal': ConfirmationModal,
    'submit-modal': submitModal,
    'contact-component': contactComponent,
    'account-structure-table-component': accountStructureTableComponent,
    credentialsModal
  },
  directives: {
    mask
  },
  computed: {
    required() {
      return required
    },
	  targets() {
		  return targets
	  },
    linkedBPTableFields() {
      return this.tableList.fields.filter(field => field.key !== 'checkbox');
    },
    fourHorsemen: function () {
      let array = [this.integrationData.account.administratorUserId,
        this.integrationData.account.primaryContactUserId,
        this.integrationData.account.primarySalesLeadUserId,
        this.integrationData.account.primaryServiceLeadUserId];
      //need to turn null into 0 because nulls are not passed into validator, we always need 4 elements
      for (let i in array) {
        if (array[i] == null)
          array[i] = 0;
      }
      return array;
    }
  },
  data() {
    return {
      clicked: false,
      instance: instance,
      showErrors: false,
      forceUpdate: 0,
      confirmUpdateMessage: [],
      statusMessages: [],
      bmsContactCopies: [],
      userBranches: [],
      submitLoading: false,
      pendingAction: null,
      selectedUserAgency: '',
      selectedPostal: '',
      selectedAccountName: '',
      isLoading: true,
      isContactLoading: false,
      selectedClientReady: false,
      validating: false,
      breadcrumbs: [
        {text: this.$t("Integrations"), to: {name: 'Integrations'}},
        {text: this.$t("Integration"), active: true}
      ],
      integrationData: {
        integration: null,
        account: null,
        contacts: [],
        opportunity: null,
        policy: {}
      },
      bpUserLocation: null,
      accountData: null,
      primarySalesLeadData: [],
      primaryServiceLeadData: [],
      adminData: [],
      primaryContactData: [],
      epicSicCodeData: [],
      epicNaicsCodeData: [],
      isTeamMemberButNotOfFourHorsemen: false,
      newClient: 'match',
      newContact: '',
      syncAccountEnabled: true,
      tableList: {
        mainHeader: this.$t("CurrentClientAccount"),
        idProperty: "accountId",
        filterOn: ["accountName", "doingBusinessAs", "status", "city", "state"],
        filter: null,
        dataArray: [],
        currentPage: 1,
        initialValue: null,
        fields: [
          {key: "checkbox", label: "", sortable: false},
          {key: "accountName", label: this.$t("Name"), sortable: true},
          {key: "doingBusinessAs", label: this.$t("DBA"), sortable: true},
          {key: "status", label: this.$t("Status"), sortable: true},
          {key: "city", label: this.$t("City"), sortable: true},
          {key: "state", label: this.$t("StateProvince"), sortable: true}
        ]
      },
      primaryProducerData: [],
      primaryServicerData: [],
      accountCollapsed: false,
      additionalAccountLabel: this.$t("ShowMoreFields"),
      isBP: true,
      datePickerFormat: this.$t("DatePickerFormat"),
      datePickerMask: '##/##/20##',
      primaryContactValidationError: false,
      openInBus: false,
      busAccountLaunched: false,
      clientNotSelected: false,
      showClientList: false,
      showInvalidMatchedIDErrorBP: false,
      showDuplicateMatchedIDErrorBP: false,
      showBPSearchError: false,
      newClientEnabled: true,
      coreProducerName: '',
      searchingProducer: false,
      coreServicerName: '',
      searchingServicer: false,
      defaultServicer: null,
      defaultProducer: null,
      defaultAdministrator: null,
      defaultPrimaryContact: null,
      defaultPrimarySalesLead: null,
      structureOfSelectedAccount: [],
      userAgencies: [],
      duplicateUrl: null,
      latestClientSearchHadNoResults: false,
      client: null,
      selectedContacts: [],
      isLinkedBPClient: false
    }
  },
  created() {
  },
  watch: {
    newClient: function (newVal) {
      let app = this;
      if (newVal === 'create' && this.latestClientSearchHadNoResults) {
        this.newClient = 'match';
        return;
      }
      if (newVal === 'create') {
        let selectedVal = this.tableList.dataArray.find(x => x.isSelected);
        if (selectedVal)
          selectedVal.isSelected = false;
        if (this.integrationData.account)
          this.integrationData.account.matchedAccountID = 0;
        this.integrationData.syncAccount = true;
        this.syncAccountEnabled = false;
        if (this.integrationData.account.isPersonalLine) {
          this.integrationData.syncAccount = true;
          this.integrationData.syncContact = true;
        }
        if (this.$route.params.din === app.instance.viu) {
          this.integrationData.syncPolicy = true;
        }
        if (this.integrationData.account.isHousehold) {
          this.selectedContacts = this.integrationData.contacts
            ? this.integrationData.contacts.filter(
              x => x.contactID == this.integrationData.opportunity.parentContactID
            ).slice(0, 1)
            : [];
        } else {
          this.selectedContacts = this.integrationData.contacts;
        }
        this.structureOfSelectedAccount = [];
      } else {
        this.syncAccountEnabled = true;
        this.showClientList = true;

        if (this.integrationData.account.isHousehold) {
          this.selectedContacts = this.integrationData.contacts
            ? this.integrationData.contacts.filter(
              x => x.contactID == this.integrationData.opportunity.parentContactID
            ).slice(0, 1)
            : [];
        } else {
          this.selectedContacts = this.integrationData.contacts;
        }

        if (this.integrationData.account.matchedAccountID !== 0 && !this.latestClientSearchHadNoResults)
          this.newClientEnabled = false;
        else
          this.newClientEnabled = true;
      }
    },
  },
	mounted() {
		this.datePickerPattern =  /(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d/g;

    this.isLoading = false;

    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener('hashchange', this.hashChangeHandler);
    }

    this.ensureBPSessionActive(() => this.loadPageData(false));
  },
  destroyed: function () {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener('hashchange', this.hashChangeHandler);
    }
  },
  methods: {
    getBPAccountPrimaryKey(integrationData) {
      if (!integrationData || !integrationData.account) {
        return null;
      }

      if (integrationData.account.bpPrimaryKey) {
        return integrationData.account.bpPrimaryKey;
      }

      if (integrationData.account.isPersonalLine === true && Array.isArray(integrationData.contacts)) {
        const linkedContact = integrationData.contacts.find(contact => contact.bpAccountPK);
        return linkedContact ? linkedContact.bpAccountPK : null;
      }

      return null;
    },
    hasLinkedBPAccount(integrationData) {
      return this.getBPAccountPrimaryKey(integrationData) !== null;
    },
    loadLinkedBPAccountSummary(isRefresh) {
      const bpPrimaryKey = this.getBPAccountPrimaryKey(this.integrationData);
      this.isLoading = true;

      const groupAccount = !this.integrationData.account.isPersonalLine;

      return axios.get(`bix/accounts?bpPrimaryKey=${bpPrimaryKey}&nocache=${isRefresh}&groupAcct=${groupAccount}&timestamp=${new Date().getTime()}`)
        .then(response => {
          this.tableList.dataArray = response.data && Array.isArray(response.data.summaries)
            ? response.data.summaries
            : [];
          this.isLoading = false;
        })
        .catch(error => {
          this.tableList.dataArray = [];
          this.isLoading = false;
          console.log('Error occured:' + error);
        });
    },
    toggleOpenInBus(toggleValue) {
      this.openInBus = toggleValue;
    },

    ensureBPSessionActive(nextAction) {
      const ts = Date.now();
      this.pendingAction = (typeof nextAction === 'function') ? nextAction : null;

      axios.get(`/users/current/session/is-active?nocache=true&timestamp=${ts}`)
        .then(({ status, data }) => {
          if (status === 200 && data === true) {
            const fn = this.pendingAction;
            this.pendingAction = null;
            if (fn) fn();
          } else {
            this.$refs.credentialsModal.show();
          }
        })
        .catch(() => {
          // On any error, force re-auth
          this.$refs.credentialsModal.show();
        });
    },


    continueAfterLogin(resume) {
      if (resume === true && typeof this.pendingAction === 'function') {
        const fn = this.pendingAction;
        this.pendingAction = null;
        fn();
      }
    },

    submitOkClick() {
      if (this.primaryContactValidationError) {
        this.primaryContactValidationError = false;
        this.$refs.submitModal.hideSubmitModal();
      } else
        this.$router.push({ name: 'Integrations' });
    },
    forceCorrectDate,
    onSubmit() {
      this.showErrors = true;
      let validationErrors = false;
      let hasPrimaryContact = false;
      this.busAccountLaunched = false;
      if (this.integrationData.syncContact && this.integrationData.contacts) {
        if (this.integrationData.account.isHousehold) {
          hasPrimaryContact = true;
        }
        else {
          this.integrationData.contacts.forEach((item, index) => {
            if ((item.hasValidationError || item.showEmailNotUniqueError) ||
              (this.integrationData.syncContact && item.newContact === 'match' && item.matchedContactID === 0))
              validationErrors = true;

            if (this.integrationData.account.isPersonalLine && item.primaryContact === true)
              hasPrimaryContact = true;
          });
        }
      }
      if (this.checkValidationErrors(hasPrimaryContact)) {
          validationErrors = true;
          if (this.hasPrimaryContactRequiredError(hasPrimaryContact)) {
            this.updateSubmitStatusMessage('Account', this.$t("PrimaryContactRequired"), false, true);
            this.primaryContactValidationError = true;
            this.$refs.submitModal.showSubmitModal();
          }
        }
     
      if (validationErrors)
        return;

      this.setConfirmMessage();
      this.$refs.confirmSubmit.showConfirmationModal(this.confirmSubmitRequest);
    },
    checkValidationErrors(hasPrimaryContact) {
      return this.hasClientNotSelectedError() || this.hasMustSyncSomethingError() || this.hasPrimaryContactRequiredError(hasPrimaryContact) || this.showSelectClient();
    },
    hasClientNotSelectedError() {
      return this.integrationData.syncAccount && this.newClient === 'match' && this.integrationData.account.matchedAccountID === 0;
    },
    hasMustSyncSomethingError() {
      return !this.integrationData.syncAccount && !this.integrationData.syncPolicy && !this.integrationData.syncContact;
    },
    hasPrimaryContactRequiredError(hasPrimaryContact) {
      let retVal = false;

      if (this.newClient === 'create' && this.integrationData.account.isPersonalLine && hasPrimaryContact === false)
        retVal = true;

      return retVal;
    },
    showSelectClient() {
      return ((this.integrationData.syncContact || this.integrationData.syncPolicy) && this.newClient === 'match') && (!this.integrationData.account || this.integrationData.account.matchedAccountID == 0);
    },
    // Submit Request(s)
    cancelSubmitRequest() {
      // Don't think we need this
    },
    confirmSubmitRequest() {
      this.ensureBPSessionActive(() => this.doConfirmSubmitRequest());
    },

    doConfirmSubmitRequest() {
      let app = this;
      this.statusMessages = [];
      this.$bvModal.hide('policyHeaderFields');
      this.$refs.submitModal.showSubmitModal();
      this.submitLoading = true;
      this.integrationData.updateStatus = "Success";
      this.integrationData.updateAccountId = this.integrationData.account.matchedAccountID;
      this.integrationData.updateContactId = 0;
      this.integrationData.updatePolicyId = 0;

      let contacts = null;
      if (this.integrationData.contacts) {
        contacts = this.integrationData.contacts.filter(x => x.newContact === 'create' || x.newContact === 'match');
      }

      this.submitAccount()
        .then((result) => {
          if (result) app.integrationData.updateAccountId = result;
          else app.integrationData.updateAccountId = app.integrationData.account.matchedAccountID;

          const promises = [];
          if (contacts) contacts.forEach(item => promises.push(this.submitContact(item)));
          return Promise.all(promises);
        })
        .then(() => {
          if (this.integrationData.updateStatus === 'Failed') return this.submitComplete("Failed");
          return this.submitComplete("Success");
        })
        .catch(() => {
          this.submitLoading = false;
          return this.submitComplete("Failed");
        });
    },

    submitComplete(status) {
      if (status === 'Success') {
        return this.submitCOREUpdateStatus(status).then((response) => {
          // done
          this.submitLoading = false;
        }).catch(error => {
          // error updating status
          this.submitLoading = false;
        });
      } else {
        this.submitLoading = false;
      }
    },
    submitComplete(status) {
      if (status === 'Success') {
        return this.submitCOREUpdateStatus(status).then((response) => {
          // done
          this.submitLoading = false;
        }).catch(error => {
          // error updating status
          this.submitLoading = false;
        });
      } else {
        this.submitLoading = false;
      }
    },

    submitAccount() {
      // If we're syncing account, return the promise, otherwise, resolve
      const postUrl = `integrations/accounts/${this.integrationData.account.accountID}/submittobp`;
      const postData =  {
        account: this.integrationData.account,
        primaryContact: this.integrationData.contacts ? this.integrationData.contacts.filter(x => x.primaryContact === true)[0] : null
      };
      if (this.integrationData.syncAccount) {
        this.updateSubmitStatusMessage('account', this.$t("SubmittingAccount"), true, false);
        return axios.post(postUrl, postData).then((response) => {
          const accountId = response.data.accountId;
          if (this.openInBus && !this.busAccountLaunched) {
            this.busAccountLaunched = true;
            window.open(response.data.busUrl, '_blank');
          }

          this.updateSubmitStatusMessage('account', this.$t("AccountSubmitted", {0: this.integrationData.account.name}), false, false);
          console.log("Account submitted " + accountId);
          return accountId;
        }).catch(error => {
          if (error.response && error.response.data) {
            if (error.response.data.accountId) {
              this.updateSubmitStatusMessage('account', this.$t("AccountSubmitted", {0: this.integrationData.account.name}), false, false);
              console.log("Account submitted " + error.response.data.accountId);

              this.integrationData.updateStatus = "Failed";
              if (error.response.data.error.error) {
                console.log(this.$t("ErrorOccurred", {0: error.response.data.error.error}));
                throw new Error(error.response.data.error);
              } else {
                console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
              }
            } else
              console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
          } else {
            console.log(this.$t("ErrorOccurred", {0: error}));
          }
          this.updateSubmitStatusMessage('account', this.$t("AccountSubmitFailed"), false, true);
          this.integrationData.updateStatus = "Failed";
          throw new Error(error);
        });
      } else {
        return Promise.resolve(); // TODO: return matched account id
      }
    },
    submitContact(contact) {
      const postUrl  = `integrations/contacts/${contact.contactID}/submittobp/${this.integrationData.updateAccountId}`;

      if (this.integrationData.syncContact && this.integrationData.updateAccountId !== 0) {
        this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("SubmittingContact", {0: contact.lastName + ", " + contact.firstName}), true, false);
        return axios.post(postUrl, contact).then((response) => {
          const contactId = response.data.contactId;
          if (this.openInBus && !this.busAccountLaunched) {
            this.busAccountLaunched = true;
            window.open(response.data.busUrl, '_blank');
          }

          this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("ContactUpdated", {0: contact.lastName + ", " + contact.firstName}), false, false);
          console.log("Contact submitted " + contactId);
          return response.data;
        }).catch(error => {
          this.integrationData.updateStatus = "Failed";
          this.updateSubmitStatusMessage(`contact${contact.contactID}`, this.$t("ContactFailedUpdate", {0: contact.lastName + ", " + contact.firstName}), false, true);
          console.log("Failed to update contact " + contact.firstName + contact.lastName);
          if (error.response && error.response.data && error.response.data.error) {
            console.log(this.$t("ErrorOccurred", {0: error.response.data.error}));
          } else {
            console.log(this.$t("ErrorOccurred", {0: error}));

          }
          throw new Error(error);
        });
      } else {
        return Promise.resolve();
      }
    },
    submitCOREUpdateStatus(status) {
      this.updateSubmitStatusMessage('core', this.$t("UpdatingIntegrationRequest"), true, false);
      let statusMessage = "";
      if (status === 'Success')
        statusMessage = this.$t("Success");
      else if (status === 'Failed')
        statusMessage = this.$t("Failed")

      return axios.post(`integrations/${this.integrationData.integrationID}/updatestatus/${status}?dynamicsInstanceName=${this.integrationData.dynamicsInstanceName}&destination=${this.integrationData.targetSystem}`, null).then((response) => {
        this.updateSubmitStatusMessage('core', this.$t("IntegrationRequestClosed", {0: statusMessage}), false, false);
        return response.data;
      }).catch(error => {
        this.updateSubmitStatusMessage('core', this.$t("ErrorClosingRequest", {0: statusMessage}), false, true);
        console.log(this.$t("ErrorOccurred", {0: error}))
      });
    },
    setConfirmMessage() {
      console.log("do i make it to seeing the confirm message?");
      const h = this.$createElement;
      let app = this;
      let vNodes = [];

      vNodes.push(h('p', this.$t("FollowingWillBePerformed")));

      //false if you are creating
      if (this.integrationData.syncAccount && !this.integrationData.account.isHousehold) {
        let account = this.tableList.dataArray.find(x => x.accountId == this.integrationData.account.matchedAccountID);

        if (this.integrationData.account.isPersonalLine !== true) {
          vNodes.push(h('div', this.newClient === 'match' ? this.$t("CoreAccountMatched", {0: account.accountName}) : this.$t("NewClientCreatedForCore", {0: this.integrationData.account.name})));
        } else if (this.integrationData.account.isPersonalLine && this.integrationData.contacts.length > 0) {
          vNodes.push(h('div', this.newClient === 'match' ? this.$t("CoreContactMatchedClient", {0: account.accountName}) : this.$t("NewIndividualLineCreated", {0: this.integrationData.contacts[0].fullName})));
        }
      }
      else if (this.integrationData.account.isHousehold) {
        vNodes.push(h('div', ''));
        var singleContact = this.selectedContacts[0];
        const contactName = `${singleContact.firstName} ${singleContact.lastName}`;
        vNodes.push(h('div', this.newClient === 'match'
          ? this.$t("CoreContactMatchedClient", { 0: contactName })
          : this.$t("NewIndividualLineCreated", { 0: contactName })));
      }
      else if (this.integrationData.syncContact && this.integrationData.contacts) {
        vNodes.push(h('div', ''));
        this.integrationData.contacts.forEach((item, index) => {
          if (item.newContact && item.newContact !== 'donotsync' && app.bmsContactCopies.length > 0) {
            let bmsContact = app.bmsContactCopies[0].find(x => x.contactId.toString() === item.matchedContactID);

            if (this.integrationData.account.isPersonalLine !== true) {
              vNodes.push(h('div', item.newContact === 'match' ? this.$t("CoreContactMatchedContact", {
                0: item.firstName + " " + item.lastName,
                1: bmsContact.firstName + " " + bmsContact.lastName
              }) : this.$t("NewContactCreatedForCore", {0: item.firstName + " " + item.lastName})));
            }
          } else {
            if (item.newContact === 'create') {
              if (this.integrationData.account.isPersonalLine !== true) {
                vNodes.push(h('div', this.$t("NewContactCreatedForCore", {0: item.firstName + " " + item.lastName})));
              }
            }
          }
        });
      }

      this.confirmUpdateMessage = vNodes;
    },
    updateSubmitStatusMessage(id, text, isLoading, isError) {
      let message = this.statusMessages.find(x => x.id === id);
      if (message) {
        message.text = text;
        message.isLoading = isLoading;
        message.isError = isError;
      } else {
        this.statusMessages.push({id: id, text: text, isLoading: isLoading, isError: isError});
      }
    },
    loadPageData(isRefresh) {
      // load CoreIntegration record
      this.isLoading = true;
      let app = this;

      axios.get(`integrations/new/bp/${this.$route.params.integrationId}/din/${this.$route.params.din}`).then((response) => {
        if (response.data) {
          app.integrationData = response.data;
          app.breadcrumbs[1].text = app.integrationData.name;

          app.isLinkedBPClient = app.hasLinkedBPAccount(app.integrationData);
          if (app.isLinkedBPClient) {
            app.loadLinkedBPAccountSummary(isRefresh);
            return;
          }

          app.bpUserLocation = response.data.bpUserLocation;
          if (app.integrationData.account.administratorUserId === 0) {
            app.integrationData.account.administratorUserId = null;
          }
          if (app.integrationData.account.primaryContactUserId === 0) {
            app.integrationData.account.primaryContactUserId = null;
          }
          if (app.integrationData.account.producerName === 0) {
            app.integrationData.account.producerName = null;
          } else
            app.coreProducerName = app.integrationData.account.producerName;
          if (app.integrationData.account.servicer.id === 0) {
            app.integrationData.account.servicer.id = null;
          } else
            app.coreServicerName = app.integrationData.account.servicer.id;
          if (app.integrationData.account.primaryServiceLeadUserId === 0) {
            app.integrationData.account.primaryServiceLeadUserId = null;
          }

          this.defaultProducer = {
            id: app.integrationData.account.producerName,
            name: app.integrationData.account.producerNameName
          };
          if (this.defaultProducer.id && this.defaultProducer.name) {
            this.primaryProducerData = common.buildDefaultOption(this.defaultProducer.id, this.defaultProducer.name);
          }

          this.defaultServicer = common.safeClone(app.integrationData.account.servicer);
          if (this.defaultServicer.id && this.defaultServicer.name) {
            this.primaryServicerData = common.buildDefaultOption(this.defaultServicer.id, this.defaultServicer.name);
          }

          this.defaultAdministrator = {
            id: app.integrationData.account.administratorUserId,
            name: app.integrationData.account.administratorName
          }
          if(this.defaultAdministrator.id && this.defaultAdministrator.name){
            this.adminData = common.buildDefaultOption(this.defaultAdministrator.id, this.defaultAdministrator.name);
          }

          this.defaultPrimaryContact = {
            id: app.integrationData.account.primaryContactUserId,
            name: app.integrationData.account.primaryContactName
          }
          if(this.defaultPrimaryContact.id && this.defaultPrimaryContact.name){
            this.primaryContactData = common.buildDefaultOption(this.defaultPrimaryContact.id, this.defaultPrimaryContact.name);
          }

          this.defaultPrimarySalesLead = {
            id: app.integrationData.account.primaryServiceLeadUserId,
            name: app.integrationData.account.primaryServiceLeadName
          }
          if(this.defaultPrimarySalesLead.id && this.defaultPrimarySalesLead.name){
            this.primaryServiceLeadData = common.buildDefaultOption(this.defaultPrimarySalesLead.id, this.defaultPrimarySalesLead.name);
          }

          this.loadAccounts(true);
          this.showClientList = false;
          //modal is now shown inside loadAccounts if necessary or skipped if not.
          this.setDefaults();
        }
      })
          .catch(error => {
            app.isLoading = false;
            console.log('Error occured:' + error)
          });
    },
    refreshPage() {
      this.loadPageData(true);
    },
    toggleAccounts() {
      this.accountCollapsed = !this.accountCollapsed;
      this.additionalAccountLabel = this.accountCollapsed ? this.$t("ShowFewerRequiredFields") : this.$t("ShowMoreFields");
    },
    formatDollar(value) {
      if (this.$i18n.locale === 'fr') {
        const formatter = new Intl.NumberFormat('fr-CA', {
          style: 'currency',
          currency: 'CAD',
          minimumFractionDigits: 2
        });

        return formatter.format(value);
      } else {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        });

        return formatter.format(value);
      }
    },
    submitPolicyHeader() {

    },
    loadAccounts(isRefresh) {
      this.isLoading = true;
      let app = this;

      axios.get(`bix/accounts/account-default?nocache=${isRefresh}&timestamp=${new Date().getTime()}&groupAcct=${!this.integrationData.account.isPersonalLine}`)
          .then((response) => {
            if (response.data) {
              app.accountData = response.data;
            }
          })
          .then(function () {
            let bpPrimaryKey = null;
            if (app.integrationData.account.bpPrimaryKey)
              bpPrimaryKey = app.integrationData.account.bpPrimaryKey;
            else if (app.integrationData.account.isPersonalLine && !IsArrayNotPopulated(app.integrationData.contacts) && app.integrationData.contacts[0].bpAccountPK)
              bpPrimaryKey = app.integrationData.contacts[0].bpAccountPK;
            if (bpPrimaryKey) {
	            axios.get(`bix/accounts/${bpPrimaryKey}?nocache=${isRefresh}&timestamp=${new Date().getTime()}`)
		            .then(response => {
			            app.isLoading = false;
						      let summaries = [];
									//Is this necessary?  There's no updated date on the summary response.
							    if(response.data.summary){
								    response.data.summary.updatedDate = moment.utc(response.data.summary.updatedDate).format('MM/DD/YYYY');
							      summaries.push(response.data.summary);
									}

			            app.tableList.dataArray = summaries;
			            if (summaries.length > 0) {
				            app.matchedAccount(bpPrimaryKey, response.data);
				            app.selectClient();
				            app.tableList.initialValue = bpPrimaryKey;
			            } else {
				            app.showInvalidMatchedIDErrorBP = true;
				            app.createNewClient();
			            }
			            return (response.data.summaries);
		            }).catch(error => {
		            app.isLoading = false;
		            return [];
	            });

            } else {
              app.isLoading = false;
              app.createNewClient();
              return [];
            }
          });
    },
    refreshBPAccounts() {
      if (this.selectedAccountName || this.selectedPostal) {
        this.showBPSearchError = false;
        this.showInvalidMatchedIDErrorBP = false;
        this.showDuplicateMatchedIDErrorBP = false;
        this.duplicateUrl = null;
        let app = this;
        app.isLoading = true;
        axios.get(`bix/accounts?nocache=true&searchText=${encodeURIComponent(this.selectedAccountName)}&postalCode=${this.selectedPostal}&timestamp=${new Date().getTime()}&groupAcct=${!app.integrationData.account.isPersonalLine}&postalCode=${app.integrationData.account.address1PostalCode}`).then(response => {
          app.isLoading = false;
          for (let item in response.data.summaries) {
            response.data.summaries[item].updatedDate = moment.utc(response.data.summaries[item].updatedDate).format('MM/DD/YYYY');
          }
          app.tableList.dataArray = response.data.summaries;
          return (response.data.summaries);
        }).catch(error => {
          app.isLoading = false;
          return []
        });
      } else {
        this.showBPSearchError = true;
      }
    },
    formatDate(date) {
      return moment.utc(date).format(this.$t('DateFormat'))
    },
    matchedAccount(accountID, account) {
      console.log(accountID)
      let app = this;
      //selectedClientReady is necessary because when the user selects a client from the list, the system calls out
      //to load contacts, and the response is sometimes slow.  If the user tries to click "OK" (ie match) before the contacts have
      //returned, the app won't be able to validate that the selected client isn't already tied to another account.
      //So we need to keep the OK button disabled until that contact query comes back and the validation can be triggered
      //properly.
      app.selectedClientReady = false;
      if (accountID !== 0) {
        app.validating = true;
      }
      app.showDuplicateMatchedIDErrorBP = false;
      this.duplicateUrl = null;
      this.initialValue = null;
      if (this.integrationData.account)
        this.integrationData.account.matchedAccountID = accountID;

      if (accountID !== 0) {
        app.integrationData.account.matchedAccountID = accountID;
        if (account !== null && account !== undefined) {

					this.bindMatchedAccount(accountID, account);
					this.afterMatchedAccountLoaded(accountID);
				}else{
					this.loadMatchedAccount(accountID);
				}
      } else {
        app.newContact = null;
        app.bmsContactCopies = [];
        app.integrationData.account.matchedAccountID = 0;
        let account = JSON.parse(JSON.stringify(app.integrationData.account));
        account.legalEntityName = null;
        account.brokerRecordDate = null;
        account.primaryServiceLeadUserId = null;
        this.primaryServiceLeadData = [];
        account.administratorUserId = null;
        this.adminData = [];
        account.primaryContactUserId = null;
        this.primaryContactData = [];
        account.producerName = null;
        account.producerNameName = null;
        this.primaryProducerData = [];
        account.servicer = {id: null, name: null};
        this.primaryServicerData = [account.servicer];
        account.regionId = null;
        account.regionName = null;
        account.officeId = null;
        account.officeName = null;
        account.departmentId = null;
        account.departmentName = null;
        account.taxPayerId = null;

        if (account.isPersonalLine) {
          account.dob = null;
          account.maritalStatus = null;
          account.gender = null;
        } else {
          account.businessType = "None";
          account.marketSize = "None";
          account.primaryIndustry = "None";
        }
        app.integrationData.account = JSON.parse(JSON.stringify(account));
      }
      console.log(app.integrationData);
    },
    bindMatchedAccount(accountID, loadedAccount) {
      console.log("binding matched account ", loadedAccount);
      this.client = loadedAccount
		  let app = this;
		  let account = JSON.parse(JSON.stringify(app.integrationData.account));
		  account.legalEntityName = loadedAccount.doingBusinessAs;

		  if (loadedAccount.brokerRecordDate)
			  account.brokerRecordDate = new Date(loadedAccount.brokerRecordDate);

		  if (loadedAccount.teamMembers) {
			  let serviceLead = loadedAccount.teamMembers.filter(x => x.id === loadedAccount.primaryServiceLeadUserId);
			  if (serviceLead.length > 0) {
				  account.primaryServiceLeadUserId = loadedAccount.primaryServiceLeadUserId;
				  this.primaryServiceLeadData = common.buildDefaultOption(loadedAccount.primaryServiceLeadUserId, serviceLead[0].name);
			  }

			  let admin = loadedAccount.teamMembers.filter(x => x.id === loadedAccount.administratorUserId);
			  if (admin.length > 0) {
				  account.administratorUserId = loadedAccount.administratorUserId;
				  this.adminData = common.buildDefaultOption(loadedAccount.administratorUserId, admin[0].name);
			  }

			  let primaryContact = loadedAccount.teamMembers.filter(x => x.id === loadedAccount.primaryContactUserId);
			  if (primaryContact.length > 0) {
				  account.primaryContactUserId = loadedAccount.primaryContactUserId;
				  this.primaryContactData = common.buildDefaultOption(loadedAccount.primaryContactUserId, primaryContact[0].name);
			  }

			  let primaryProducer = loadedAccount.teamMembers.filter(x => x.id === loadedAccount.primarySalesLeadUserId);
			  if (primaryProducer.length > 0) {
				  account.producerName = loadedAccount.primarySalesLeadUserId;
				  account.producerNameName = primaryProducer[0].name;
				  this.primaryProducerData = common.buildDefaultOption(loadedAccount.primarySalesLeadUserId, primaryProducer[0].name);
			  }

			  let primaryServicer = loadedAccount.teamMembers.filter(x => x.id === loadedAccount.primaryServiceLeadUserId);
			  if (primaryServicer.length > 0) {
				  account.servicer = {id: loadedAccount.primaryServiceLeadUserId, name: primaryServicer[0].name};
				  this.primaryServicerData = [account.servicer];
			  }
		  }

		  account.regionId = loadedAccount.regionId;
		  account.regionName = loadedAccount.regionName;
		  account.officeId = loadedAccount.officeId;
		  account.officeName = loadedAccount.officeName;
		  account.departmentId = loadedAccount.departmentId;
		  account.departmentName = loadedAccount.departmentName;
		  account.taxPayerId = loadedAccount.taxpayerId;

		  if (account.isPersonalLine) {
			  account.dob = loadedAccount.dob;
			  account.maritalStatus = loadedAccount.maritalStatus;
			  account.gender = loadedAccount.gender;
		  } else {
			  account.businessType = loadedAccount.businessType;
			  account.marketSize = loadedAccount.marketSize;
			  account.primaryIndustry = loadedAccount.industry;
		  }

		  app.integrationData.account = JSON.parse(JSON.stringify(account));

	  },
	  loadMatchedAccount(accountID){
		  axios.get(`bix/accounts/${accountID}?nocache=true&timestamp=${new Date().getTime()}`).then(response => {
        console.log("wow, ", response.data)
        this.bindMatchedAccount(accountID, response.data);
		  }).then(()=> {this.afterMatchedAccountLoaded(accountID);});
	  },
	  afterMatchedAccountLoaded(accountID){
			let app = this;
		  app.isContactLoading = true;
		  axios.get(`bix/contacts/${accountID}?nocache=true&timestamp=${new Date().getTime()}`)
        .then(response => {
        console.log("bix contacts? : ", response.data)
				app.bmsContactCopies = [];
        if(!IsArrayNotPopulated(app.integrationData.contacts)){
          app.integrationData.contacts.forEach((item, index) => {
            let contactCopy = JSON.parse(JSON.stringify(response.data));
            if (app.integrationData.account.isPersonalLine) {
              if (app.integrationData.account.dob)
                item.dob = new Date(app.integrationData.account.dob);
              item.maritalStatus = app.integrationData.account.maritalStatus;
              item.gender = app.integrationData.account.gender;

              if (app.integrationData.account.isHousehold) {
                contactCopy = contactCopy.filter(
                  c => c.contactId == app.integrationData.opportunity.parentContactID
                );
              }
            }
            app.bmsContactCopies.push(JSON.parse(JSON.stringify(contactCopy)));
          });
        }
				app.isContactLoading = false;
				return (response.data);
			}).then(() => {
				//Validate the selected client isn't joined to another dynamics account.
				if (app.integrationData.account.isPersonalLine) {
					let contactid = app.getContactId(app.bmsContactCopies);
					if (contactid === null) { //if no contacts, we can't query dynamics for it.
						app.finishClientValidationBp(null);
						return;
					}
					return spaApi.getDynamicsContactByBpId(contactid, app.integrationData.dynamicsInstanceName, app.finishClientValidationBp)
				} else {
					return spaApi.getDynamicsAccountByBpId(app.integrationData.account.matchedAccountID, app.integrationData.dynamicsInstanceName, app.finishClientValidationBp);
				}
			}).catch(error => {
				app.isContactLoading = false;
				app.selectedClientReady = true;
				console.log("Error: " + error)
				return []
			});
	  },
    onSearchPrimaryProducer(search, loading) {
      if (!search) {
        return;
      }
      this.searchingProducer = true;
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.account.producerName, this.primaryProducerDataGetSet);
    },
    primaryProducerDataGetSet(apiData) {
      if (apiData) {
        this.primaryProducerData = apiData;
        this.searchingProducer = false;
      } else
        return this.primaryProducerData;
    },
    onSearchPrimaryServicer(search, loading) {
      if (!search) {
        return;
      }
      this.searchingServicer = true;
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.account.servicer.id, this.primaryServicerDataGetSet);
    },
    primaryServicerDataGetSet(apiData) {
      if (apiData) {
        this.primaryServicerData = apiData;
        this.searchingServicer = false;
      } else
        return this.primaryServicerData;
    },
    onSearchPrimaryServiceLead(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.account.primaryServiceLeadUserId, this.primaryServiceLeadDataGetSet);
    },
    onSearchAccountAdmin(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.account.administratorUserId, this.adminDataGetSet);
    },
    onSearchPrimaryContact(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.account.primaryContactUserId, this.primaryContactDataGetSet);
    },
    primarySalesLeadDataGetSet(apiData) {
      if (apiData)
        this.primarySalesLeadData = apiData;
      else
        return this.primarySalesLeadData;
    },
    primaryServiceLeadDataGetSet(apiData) {
      if (apiData)
        this.primaryServiceLeadData = apiData;
      else
        return this.primaryServiceLeadData;
    },
    adminDataGetSet(apiData) {
      if (apiData)
        this.adminData = apiData;
      else
        return this.adminData;
    },
    primaryContactDataGetSet(apiData) {
      if (apiData)
        this.primaryContactData = apiData;
      else
        return this.primaryContactData;
    },
    showTeamError() {
      if (this.disableTeamInfo()) //do not show if the whole team-info component is disabled
        return false;

      if (this.fourHorsemen.indexOf(0) > -1 || this.fourHorsemen.indexOf('0') > -1) //do not show error until all team members selected
        return false;

      return this.fourHorsemen.indexOf(this.integrationData.account.bpUserId) === -1;
    },
    disableTeamInfo() {
      return this.isTeamMemberButNotOfFourHorsemen;
    },
    primaryProducerToolTip() {
      return tooltips.originalCoreToolTip(this.coreProducerName);
    },
    primaryServicerToolTip() {
      return tooltips.originalCoreToolTip(this.coreServicerName);
    },
    showPolicyModal() {
      this.$bvModal.show('policyHeaderFields');
    },
    setDefaults() {
      this.integrationData.policy.renewalDate = '';
      if (this.integrationData.policy.effectiveDate) {
        // Replace T with Z in the .NET timestamp string to force UTC parsing instead of local parsing
        // This way the time matches what you get when manually selecting a date in the UI
        this.integrationData.policy.effectiveDate = new Date(this.integrationData.policy.effectiveDate.replace("T", "Z"));
        if (isNaN(this.integrationData.policy.effectiveDate))
          this.integrationData.policy.effectiveDate = null;
      }
      if (this.integrationData.policy.effectiveDate === null)
        this.integrationData.policy.effectiveDate = '';
      this.integrationData.policy.commissionDate = '';
      if (this.integrationData.policy.lineCommission)
        this.integrationData.policy.displayedLineCommission = this.integrationData.policy.lineCommission.toString();

    },
    setProducer(producer) {
      this.primaryProducerData = common.buildDefaultOption(producer.id, producer.name);
      this.integrationData.account.producerName = producer.id; //producerId
    },
    setServicer(servicer) {
      this.primaryServicerData = common.buildDefaultOption(servicer.id, servicer.name);
      this.integrationData.account.servicer = common.safeClone(servicer);
    },
    checkEmails(contactID) {
      let email = this.integrationData.contacts.find(x => x.contactID === contactID).email;
      if (email) {
        let numMatches = this.integrationData.contacts.filter(x => x.email === email && (x.newContact && x.newContact === 'create')).length;
        if (numMatches > 1 && !this.integrationData.account.isHousehold) {
          this.integrationData.contacts.forEach((item, index) => {
            if (item.email === email && (item.newContact && item.newContact === 'create'))
              item.showEmailNotUniqueError = true;
            else
              item.showEmailNotUniqueError = false;
          });
        } else {
          this.integrationData.contacts.forEach((item, index) => {
            item.showEmailNotUniqueError = false;
          });
        }
      }
      this.forceUpdate += 1;
    },
    bpPrimaryContactChanged(contactID) {
      this.integrationData.contacts.forEach((item, index) => {
        if (item.primaryContact === true && item.contactID !== contactID)
          item.primaryContact = false;
      });
    },
    getContactId(contactCopies) {
      //This is recursive because sometimes (or always, not sure) the actual element is nested.
      //Instead of hardcoding to copies[0][0] I want to make this find copy where it can.
      if (contactCopies !== null && contactCopies.length > 0) {
        let copy = contactCopies[0];
        if (copy instanceof Array) {
          return this.getContactId(copy);
        }
        //BP and Epic contacts have different casing.
        if (copy.contactId !== undefined) {
          return copy.contactId;
        }
        if (copy.contactID !== undefined) {
          return copy.contactID;
        }
      }
      return null;
    },
    selectClient() {
      if (!this.integrationData.account || this.integrationData.account.matchedAccountID === 0)
        this.clientNotSelected = true;
      else {
        this.clientNotSelected = false;
        this.newClient = "match";
        this.showClientList = true;
      }
    },
    finishClientValidationBp(existingAccount) {
      if (existingAccount !== null && existingAccount instanceof Object && (this.isMismatchedContact(existingAccount)) || this.isMismatchedAccount(existingAccount)) {
        this.showDuplicateMatchedIDErrorBP = true;
        this.duplicateUrl = existingAccount.dynamicsUrl;
      } else {
        this.selectedClientReady = true;
      }
      this.validating = false;
    },
    isMismatchedContact(existing) {
      //no contact exists, we're good
      if (existing === undefined || existing === null || existing.contactID === undefined || existing.contactID === null) {
        return false;
      }
      if (existing.contactID !== this.integrationData.contacts[0].contactID) {
        return true;
      }
      return false;
    },
    isMismatchedAccount(existing) {
      if (existing === undefined  || existing === null ||  existing.accountID === undefined || existing.accountID === null) {
        return false;
      }
      if (existing.accountID !== this.integrationData.account.accountID) {
        return true;
      }
      return false;
    },
    createNewClient() {
      this.newClient = "create";
      this.showClientList = false;
    },
    mapKeydownOverride(map, vselect) {
      map[13] = e => this.suppressEnterWhenLoading(e, vselect);
      return map;
    },
    suppressEnterWhenLoading(e, vselect) {
      if (this.searchingProducer || this.searchingServicer) {
        e.preventDefault();
      } else {
        e.preventDefault();
        return vselect.typeAheadSelect();
      }
    }
  }
}
</script>
